export const BUSINESS = {
  name: "MRQK UK",
  addressLines: ["3rd Floor, Old Stock Exchange", "St Nicholas Street", "Bristol", "Avon", "BS1 1TG", "United Kingdom"],
  addressOneLine: "3rd Floor, Old Stock Exchange, St Nicholas Street, Bristol, Avon, BS1 1TG, United Kingdom",
  email: "Marqueukstore@proton.me",
  site: "marqueukstore.com",
};
